// Import and register all controllers
import { application } from "./application"

// Import controllers
import FrameRefreshController from "./frame_refresh_controller"
import NudgeModalController from "./nudge_modal_controller"
import DecayDirectionController from "./decay_direction_controller"
import ReboundFormController from "./rebound_form_controller"
import ScaleFormController from "./scale_form_controller"
import SortableController from "./sortable_controller"
import TrackerKindController from "./tracker_kind_controller"
import TrackerLinksController from "./tracker_links_controller"
import TrackerPlaygroundController from "./tracker_playground_controller"

// Register controllers
application.register("frame-refresh", FrameRefreshController)
application.register("nudge-modal", NudgeModalController)
application.register("decay-direction", DecayDirectionController)
application.register("rebound-form", ReboundFormController)
application.register("scale-form", ScaleFormController)
application.register("sortable", SortableController)
application.register("tracker-kind", TrackerKindController)
application.register("tracker-links", TrackerLinksController)
application.register("tracker-playground", TrackerPlaygroundController)
